import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

import { DebounceClickDirectiveModule } from 'src/app/directives/debounce-click/debounce-click-directive.module';
import { DepartmentChargeAccountPaymentModal } from './department-charge-account.modal';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoSelectDirectiveModule } from 'src/app/directives/transloco-select/transloco-select.module';

@NgModule({
  declarations: [DepartmentChargeAccountPaymentModal],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslocoModule,
    TranslocoSelectDirectiveModule,
    DebounceClickDirectiveModule,
    NgSelectModule
  ],
  exports: [DepartmentChargeAccountPaymentModal]
})
export class DepartmentChargeAccountPaymentModalModule {}
